import React from "react";
import { Button, message } from 'antd';
import getSize from "../../utils/getSize";
import NHFetch from "../../utils/NHFetch";
import NHTable from '../common/NHTable';
import EditForm from './EditForm.js';
import css from './index.css';
import { NHConfirm } from '../common/NHModal';
import NHModal from "../common/NHModal";
import { hasAuth } from '../../utils/NHCore';
const gzmc = "zhxg_yxxt_xhgz";
const basicUrl = "/newStudent/";


/**
 * 学生班级管理 
 */
class classManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRows: {},
            formInitData: {},
            frameVisibleMap: {
                tableFlag: true,
                updateFlag: false,
            },
            xspkids: []
        };
    }
    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            if (name == showFlagName) {
                frameVisibleMap[name] = true;
            } else {
                frameVisibleMap[name] = false;
            }
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    }
    //关闭内嵌页面
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
        this.refs.nhTable.filterTableData();
    }



    //调整班级按钮点击事件
    handleUpdateBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        let selectedRows = this.refs.nhTable.state.selectedRows;
 

        if (selectedRowKeys && selectedRowKeys.length > 0) {
            //判断该学生是否有学号 
            for (let key in selectedRows) {
                if (selectedRows[key].XH != null && selectedRows[key].XH != undefined) {
                    message.warning("存在已有学号的学生，请清除学号后再调整班级！");
                    return;
                }
            }  
        } else {
            message.warning("请选择需要修改班级的学生！");
            return;
        }

        this.setState({
            xspkids: selectedRowKeys
        }, this.nhModal.show());
    }

    //清除学生学号按钮点击事件
    handleClearXhBtnClick = () => {
        let xspkids = this.refs.nhTable.state.selectedRowKeys;
        if (xspkids == null || xspkids.length == 0) {
            message.warning("请选择需要清除学号的学生！");
            return;
        }

        NHConfirm("是否确定清除所选学生学号？", () => {
            NHFetch(basicUrl + 'clearXh', 'POST', xspkids).then(res => {
                if (res) {
                    if (res.data >= 1) {
                        message.success("清除成功！");
                        this.setCurrentPageShow('tableFlag'); //显示列表展示页面
                        this.refs.nhTable.filterTableData(); //刷新列表
                    } else {
                        message.error("清除失败，请联系管理员！");
                    }
                }
            }
            )
        }, "warn");
    }

    //生成学号
    handleCreateXhBtnClick = () => {
        let xspkids = this.refs.nhTable.state.selectedRowKeys;
        if (xspkids == null || xspkids.length == 0) {
            message.warning("请选择需要生成学号的学生！");
            return;
        }
        let param = {
            xspkids: xspkids,
            gzmc: gzmc
        }
        NHConfirm("是否确定生成所选学生学号？", () => {
            NHFetch(basicUrl + 'ksbxh', 'POST', param).then(res => {
                if (res && res.data >= 1) {
                    message.success("生成成功！");
                    this.setCurrentPageShow('tableFlag'); //显示列表展示页面
                    this.refs.nhTable.filterTableData(); //刷新列表 
                } 
            }
            )
        }, "warn");
    }

    //调整班级确定
    handleUpdate = () => {
        this.refs.nhUpdateForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            let params = formData;
            params['xspkids'] = this.state.xspkids;
            NHFetch(basicUrl + '/updateClass', 'POST', params).then(res => {
                if (res) {
                    if (res.data >= 1) {
                        message.success("班级调整成功！");
                        this.nhModal.close();
                        this.setCurrentPageShow('tableFlag'); //显示列表展示页面
                        this.refs.nhTable.filterTableData(); //刷新列表
                    } else {
                        message.error("班级调整失败，请联系管理员！");
                    }
                }
                this.nhModal.stopLoading();
            })
        });
    }





    onImport = () => {
        this.refs.nhExcel.show();
    }

    handleImportSuccess = () => {
        this.refs.nhTable.filterTableData();
    }


    render() {
        //列参数
        const columns = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '60px',
            }, {
                title: '年度',
                dataIndex: 'ND',
                width: '70px',
                searchType: "select"
            }, {
                title: '招生来源',
                dataIndex: 'SJLY',
                width: '100px',
                searchType: "select",
                parentField: "SJLY"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '90px',
                search: 'input',
                searchType: "input"
            }, {
                title: '性别',
                dataIndex: 'XB',
                width: '70px',
                searchType: "select"
            }, {
                title: '身份证件号',
                dataIndex: 'SFZJH',
                width: '180px',
                searchType: "input"
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '100px',
                search: 'input',
                searchType: "input"
            }, {
                title: '录取学院',
                dataIndex: 'BMMC',
                width: '150px',
                searchType: "select"
            }, {
                title: '录取专业',
                dataIndex: 'ZYMC',
                width: '150px',
                searchType: "select",
                parentField: "ZYMC"
            }, {
                title: '班级',
                dataIndex: 'BJMC',
                width: '160px',
                searchType: "select",
                parentField: "BJMC"
            }, {
                title: '调整前班级',
                dataIndex: 'TZQBJMC',
                width: '160px',
                searchType: "select",
                parentField: "TZQBJMC"
            }, {
                title: '调整原因',
                dataIndex: 'SQLY',
                width: '160px',
                searchType: "select",
                parentField: "SQLY"
            }

        ];

        //行内操作
        const action = [
            { title: '修改', onClick: this.handleUpdateBtnClick, }, // auth: 'zhxg_yxgl_bjqqManage_update'
        ];

        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                <div className={css.table} style={{ display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none' }}>

                    <NHTable
                        ref='nhTable'
                        rowKey={record => record.XSID}
                        sign={"zhxg_yxxt_newStudent_classManagement"}
                        columns={columns}
                    //action={action}  
                    >
                        {
                            hasAuth("zhxg_yxgl_classManagement_update") ?
                            <Button type="primary" onClick={this.handleUpdateBtnClick} style={{ marginLeft: 10 }}>班级调整</Button> 
                              : undefined
                        }
                        {
                            hasAuth("zhxg_yxgl_classManagement_clearXh") ?
                            <Button type="primary" ghost onClick={this.handleClearXhBtnClick} style={{ marginLeft: 10 }}>清除学号</Button>
                              : undefined
                        }
                        {
                            hasAuth("zhxg_yxgl_classManagement_createXh") ?
                            <Button type="primary" ghost onClick={this.handleCreateXhBtnClick} style={{ marginLeft: 10 }}>生成学号</Button>
                              : undefined
                        }
                        
                        
                    </NHTable>
                </div>

                <NHModal
                    ref={(form) => { this.nhModal = form }}
                    title="修改学生班级信息"
                    onOk={this.handleUpdate}
                    width={"600px"}
                >
                    <EditForm ref="nhUpdateForm" initFormData={this.state.formInitData} />
                </NHModal>

            </div>
        );
    }
}
export default classManagement;



// WEBPACK FOOTER //
// ./components/classManagement/index.js